<template>
  <div>
    <ContentHeader path-set-type="append" />
    <div class="content-wrapper" v-loading="loading">
      <el-row>
        <div class="card-top is-hover-shadow">
          <div class="card-top-left">
            <div class="top" v-if="detailList.gpThemeInfoDTO">
              <span>{{ detailList.gpThemeInfoDTO.themeName }}</span>
            </div>
            <div class="bottom">
              <div class="flex" v-if="detailList.gpThemeInfoDTO.gpPrDTOList">
                <div style="margin-right:50px;line-height:24px;" ><span class="font-weight-700">PR信息：</span>{{prInfo}}</div>
                <div style="line-height:24px;"><span class="font-weight-700">品牌信息：</span>{{brandInfo}}</div>
              </div>
            </div>
            <div class="text-left">
              <span class="font-weight-700">供应商：</span>
              <span>{{ detailList.gpPoDTO.vendorName }}</span>
            </div>
          </div>
          <div class="card-top-right" v-if="detailList.gpPoDTO">
            <div class="text-red">
              <span>PO：</span>
              <span>{{ detailList.poNumber }}</span>
            </div>

            <div class="text-time">
              <span>活动执行时间：</span>
              <span>{{
                getTime(detailList.gpThemeInfoDTO.themeStartTime, ".")
              }}</span>
              <span>-</span>
              <span>{{
                getTime(detailList.gpThemeInfoDTO.themeEndTime, ".")
              }}</span>

              <!-- <span>{{getTime(detailList.themeEndTime)}}</span> -->
            </div>
          </div>
        </div>
        <!-- 活动信息 -->
        <div class="sale-place">
          <div class="title">活动信息</div>
          <div class="sale-place-card">
            <div class="left">
              <div class="item">
                <div class="item-left">活动名称</div>
                <div class="item-right" v-if="detailList.gpThemeInfoDTO">
                  {{ detailList.gpThemeInfoDTO.themeName }}
                </div>
              </div>
              <div class="item">
                <div class="item-left">PR编码</div>
                <div class="item-right" v-if="detailList.gpThemeInfoDTO">
                  {{ prNumber }}
                </div>
              </div>
              <div class="item">
                <div class="item-left">PO编码</div>
                <div class="item-right" v-if="detailList.gpPoDTO">
                  {{ detailList.gpPoDTO.poNumber }}
                </div>
              </div>
              <div class="item">
                <div class="item-left">总金额</div>
                <div class="item-right" v-if="detailList.gpPoDTO">
                  {{ formatPrice(detailList.gpPoDTO.poAmount || 0) }} 元
                </div>
              </div>
            </div>
            <div class="right">
              <div class="item">
                <div class="item-left">活动品牌</div>
                <div class="item-right" v-if="detailList.gpThemeInfoDTO">
                  {{ brandName || '暂无' }}
                </div>
              </div>
              <div class="item">
                <div class="item-left">活动子品牌</div>
                <div class="item-right" v-if="detailList.gpThemeInfoDTO">
                  {{ subBrandName || '暂无'}}
                </div>
              </div>
              <div class="item">
                <div class="item-left">渠道</div>
                <div class="item-right" v-if="detailList.gpThemeInfoDTO">
                  {{
                    getChannel(detailList.gpThemeInfoDTO.themeChannels, "、")
                  }}
                </div>
              </div>
              <div class="item">
                <div class="item-left">已收货金额</div>
                <div class="item-right">
                  <span v-if="detailList.gpPoDTO">
                    {{ formatPrice(detailList.gpPoDTO.grAmount || 0) }} 元
                    {{ `(${formatRatio(detailList.gpPoDTO.grAmount / detailList.gpPoDTO.poAmount)})` }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 收货信息 -->
        <div class="sale-place">
          <div class="title">收货信息</div>
          <div class="content-card" style="padding:0px">
            <div class="sale-place-card ">
              <!-- Prime审核状态 -->
              <div class="request-status-box" :class="{
                  'request-status-orange': detailList.requestStatus === 300,
                  'request-status-green': detailList.requestStatus === 500,
                  'request-status-red': detailList.requestStatus === 400
                }" v-if="(menuCode !== '03' && [300, 400, 500].includes(detailList.requestStatus))">
                {{ requestStatusMap[detailList.requestStatus] }}
              </div>
              <div class="left">
                <div class="item">
                  <div class="item-left">收货时间：</div>
                  <div class="item-right">
                    {{detailList.requestTime | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-left">合同：</div>
                  <div class="item-right" v-if="detailList.gpPoDTO.dagFileUri">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="getImg(detailList.gpPoDTO.dagFileUri)"
                      v-if="handlePreviewImg(detailList.gpPoDTO.dagFileUri)"
                      :preview-src-list="[getImg(detailList.gpPoDTO.dagFileUri)]">
                    </el-image>
                    <div v-else class="view-file" @click="viewFile(detailList.gpPoDTO.dagFileUri)">查看附件</div>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="item">
                  <div class="item-left">
                    完工报告：
                  </div>
                  <div class="item-right" v-if="detailList.completeFileUri">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="getImg(detailList.completeFileUri)"
                      v-if="handlePreviewImg(detailList.completeFileUri)"
                      :preview-src-list="[getImg(detailList.completeFileUri)]">
                    </el-image>
                    <div v-else class="view-file" @click="viewFile(detailList.completeFileUri)">查看附件</div>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="item">
                  <div class="item-left">送货单：</div>
                  <div class="item-right" v-if="detailList.deliveryFileUri">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="getImg(detailList.deliveryFileUri)"
                      v-if="handlePreviewImg(detailList.deliveryFileUri)"
                      :preview-src-list="[getImg(detailList.deliveryFileUri)]">
                    </el-image>
                    <div v-else class="view-file" @click="viewFile(detailList.deliveryFileUri)">查看附件</div>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="item">
                  <div class="item-left">活动照片</div>
                  <div class="item-right" v-if="detailList.photoFileDTOList && detailList.photoFileDTOList.length">
                    <el-image v-for="item in detailList.photoFileDTOList" :key="item.fileId"
                      style="width: 100px; height: 100px;margin-right: 10px;" :src="getImg(item.fileUri)"
                      :preview-src-list="[getImg(item.fileUri)]">
                    </el-image>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="item">
                  <div class="item-left">收货备注</div>
                  <div class="item-right">
                    {{ detailList.receiveDesc || '无' }}
                  </div>
                </div>
              </div>
              <div class="right">
                <div class="item">
                  <div class="item-left">本次收货金额：</div>
                  <div class="item-right">
                    {{ formatPrice(detailList.receiveAmount) }} 元
                    {{ `(${formatRatio(detailList.receiveAmount / detailList.gpPoDTO.poAmount)})` }}
                  </div>
                </div>
                <div class="item">
                  <div class="item-left">设计方案：</div>
                  <div class="item-right" v-if="detailList.gpPoDTO.solutionFileUri">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="getImg(detailList.gpPoDTO.solutionFileUri)"
                      v-if="handlePreviewImg(detailList.gpPoDTO.solutionFileUri)"
                      :preview-src-list="[getImg(detailList.gpPoDTO.solutionFileUri)]">
                    </el-image>
                    <div v-else class="view-file" @click="viewFile(detailList.gpPoDTO.solutionFileUri)">查看附件</div>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="item">
                  <div class="item-left">KPI凭证：</div>
                  <div class="item-right" v-if="detailList.kpiFileUri">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="getImg(detailList.kpiFileUri)"
                      v-if="handlePreviewImg(detailList.kpiFileUri)"
                      :preview-src-list="[getImg(detailList.kpiFileUri)]">
                    </el-image>
                    <div v-else class="view-file" @click="viewFile(detailList.kpiFileUri)">查看附件</div>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="item">
                  <div class="item-left">费用明细及发票</div>
                  <div class="item-right" v-if="detailList.feeFileUri">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="getImg(detailList.feeFileUri)"
                      v-if="handlePreviewImg(detailList.feeFileUri)"
                      :preview-src-list="[getImg(detailList.feeFileUri)]">
                    </el-image>
                    <div v-else class="view-file" @click="viewFile(detailList.feeFileUri)">查看附件</div>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
                <div class="item">
                  <div class="item-left">礼物受益者清单</div>
                  <div class="item-right" v-if="detailList.giftFileUri">
                    <el-image
                      style="width: 100px; height: 100px"
                      :src="getImg(detailList.giftFileUri)"
                      v-if="handlePreviewImg(detailList.giftFileUri)"
                      :preview-src-list="[getImg(detailList.giftFileUri)]">
                    </el-image>
                    <div v-else class="view-file" @click="viewFile(detailList.giftFileUri)">查看附件</div>
                  </div>
                  <div v-else class="item-right item-blank">暂无附件</div>
                </div>
              </div>
            </div>
            <!-- 明细 -->
            <div style="padding:10px 10px;">
              <div class="dashed-line">&nbsp; </div>
              <!-- 待审核 -->
              <ApprovalDetailPending v-if="menuCode === '01'" :receiveDetailList="receiveDetailList"
                :detailList="detailList" :loading.sync="loading"></ApprovalDetailPending>
              <!-- 已通过 -->
              <ApprovalDetailPassed v-if="menuCode === '02'" :receiveDetailList="receiveDetailList"
                :reverseList="reverseList" :detailList="detailList" :loading.sync="loading" @on-submitReverse="init">
              </ApprovalDetailPassed>
              <!-- 紧急收货 -->
              <ApprovalDetailUrgent v-if="menuCode === '03'" :receiveDetailList="receiveDetailList"
                :detailList="detailList" :loading.sync="loading"></ApprovalDetailUrgent>
            </div>
          </div>
        </div>
      </el-row>
    </div>

  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { commonUtils } from "@/utils/common"
import ContentHeader from "@/components/content-header"
import ApprovalDetailPending from './components/receiptProportion-approvalDetail-pending.vue'
import ApprovalDetailPassed from './components/receiptProportion-approvalDetail-passed.vue'
import ApprovalDetailUrgent from './components/receiptProportion-approvalDetail-urgent.vue'
import gameplanApi from "../../api/gameplan"
export default {
  name: "activityPhoto-salePlace-detail",
  components: {
    ContentHeader,
    ApprovalDetailPending,
    ApprovalDetailPassed,
    ApprovalDetailUrgent
  },
  data() {
    return {
      loading: false,
      detailList: {
        gpThemeInfoDTO: {
          gpPrDTO: {},
          themeChannels: []
        },
        gpPoDTO: {}
      },
      menuCode: '',
      receiveId: "",
      reverseList: [],
      receiveDetailList: [],
      requestStatusMap: {
        300: 'Prime审批中',
        400: 'Prime收货失败',
        500: 'Prime收货成功'
      },
      prInfo:'',
      brandInfo:'',
      brandName:'',
      subBrandName:'',
      prNumber:''
      // menuCodeMap: {
      //   '01': '待审批',
      //   '02': '已通过',
      //   '03': '待确认凭证'
      // },
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {},
  created() {
    this.receiveId = this.$route.query.receiveId;
    this.menuCode = this.$route.query.menuCode;
    this.init();
  },
  methods: {
    init() {
      this.getReceiptdetail()
      this.getReverseList()
    },
    // 查询收货审批详情
    async getReceiptdetail() {
      let params = {
        receiveId: this.receiveId,
      };
      this.loading = true
      const { data } = await gameplanApi.getPoReverseInfo(params);
      if (data.resultCode == "0") {
        this.detailList = data.resultData.receiveInfo || {};
        this.getShowDetail()
        const poDetailList = this.detailList.gpPoDTO.poDetailList
        const receiveDetailList = this.detailList.receiveDetailList
        if (['01'].includes(this.menuCode)) {
          // 待审核
          this.receiveDetailList = poDetailList
        } else {
          // 已通过
          receiveDetailList.map(detail => {
            poDetailList.map(po => {
              if (detail.rowNumber === po.rowNumber) {
                detail.detailStatus = po.detailStatus
                detail.itemAmount = po.itemAmount
              }
            })
          })
          this.receiveDetailList = receiveDetailList
        }
      }
      this.loading = false
    },
    // 查询冲销记录
    async getReverseList() {
      if (!this.receiveId) {
        this.reverseList = []
        return
      }
      const params = {
        receiveId: this.receiveId
      }
      const { data } = await gameplanApi.getPoReverseList(params)
      if (data.resultCode === "0") {
        const reverseList = data.resultData.reverseList || {}
        this.reverseList = reverseList || []
      }
    },
    getShowDetail(){
      let prInfo = []
      let brandNameList = []
      let subBrandNameList = []
      let prNumberList = []
      let brandInfo = []
      const gpPrDTOList = this.detailList.gpThemeInfoDTO.gpPrDTOList
      if(gpPrDTOList){
        gpPrDTOList.forEach(item=>{
          if(brandNameList.indexOf(item.brandName)===-1) {
            brandNameList.push(item.brandName)
          }
          if(subBrandNameList.indexOf(item.subBrandName)===-1) {
            subBrandNameList.push(item.subBrandName)
          }
          let data = ''
          if(item.brandName&&item.subBrandName)  data = item.brandName+'-'+item.subBrandName
          else data = item.brandName||item.subBrandName
          if(brandInfo.indexOf(data)===-1) {
            brandInfo.push(data)
          }
          prInfo.push(item.prNumber+'-'+item.prName)
          prNumberList.push(item.prNumber)
        })
        this.prInfo = prInfo.join('、')
        this.brandName = brandNameList.join('、')
        this.subBrandName = subBrandNameList.join('、')
        this.prNumber = prNumberList.join('、')
        this.brandInfo = brandInfo.join('、')
      }
    },
    getTime(timestamp, a) {
      if (timestamp === 0 || timestamp == null) {
        return "";
      } else {
        var date = new Date(parseInt(timestamp)); // 时间戳为13位的话需要parseInt下
        const Y = date.getFullYear() + a;
        const M =
          (date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1) + a;
        const D =
          (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
        // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
        // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
        // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
        return Y + M + D;
      }
    },
    // 金额千分
    formatPrice(price) {
      return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    // 百分比
    formatRatio(ratio) {
      let str = Number(ratio * 100).toFixed(1)
      return str + "%";
      // return ratio * 100 + '%'
    },
    getChannel(a, b) {
      let themeChannels = a;
      let arr = themeChannels
        .map((item) => {
          return item.themeChannelEnName;
        })
        .join(b);
      return arr;
    },
    getImg(uri) {
      return commonUtils.getImageUrl(uri);
    },
    // 是否为图片
    handlePreviewImg(fileUri){
      if (!fileUri) {
        return false
      }
      const test = new RegExp("\.(gif|png|jpg|jpeg|webp|svg|psd|bmp|tif|apng|pjpeg)+");
      return !!test.exec(fileUri)
    },
    viewFile(uri){
      if (!uri) {
        return
      }
      window.open(this.getImg(uri))
    }
  },
};
</script>
<style lang="scss" scoped>
.is-hover-shadow:hover {
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
}

.content-wrapper {
  min-height: calc(100vh - 320px) !important;
  font-family: SourceHanSansSC-regular;

  .card-top {
    border-radius: 8px;
    padding: 10px 20px;
    margin-bottom: 30px;
    font-size: 14px;
    text-align: center;
    background-color: #ffffff;
    color: #101010;
    display: flex;
    justify-content: flex-start;

    .card-top-left {
      .top {
        line-height: 30px;
        color: #101010;
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        // margin-bottom: 17px;
      }

      .bottom {
        display: flex;
        justify-content: flex-start;
        font-size: 14px;
        line-height: 30px;

        .left {
          font-size: 16px;
          margin-right: 11px;
          line-height: 24px;
        }

        .right {
          // width: 72px;
          padding: 3px 8px;
          line-height: 14px;
          margin-top: 2px;
          border-radius: 4px;
          font-size: 14px;
          background-color: #ffffff;
          color: #539efe;
          border: 1px solid #539efe;
          text-align: center;
        }
      }
    }

    .card-top-right {
      flex: 1;
      text-align: right;
      color: #999999;
      min-width:255px;
      .text-time {
        line-height: 27px;
      }

      .text-red {
        line-height: 30px;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }

  .title {
    height: 50px;
    line-height: 50px;
    color: #101010;
    font-size: 18px;
    text-align: left;
    font-weight: 600;
    font-family: SourceHanSansSC-bold;
  }

  .content-card {
    padding: 10px 20px;
    background-color: #ffffff;
    border-radius: 8px;
  }

  .sale-place {
    .sale-place-card {
      padding: 10px 20px;
      background-color: #ffffff;
      border-radius: 8px;
      font-size: 14px;
      text-align: center;
      display: flex;
      position: relative;

      .left {
        width: 451px;

        .item {
          display: flex;
          font-size: 14px;
          text-align: left;
          line-height: 33px;

          .item-left {
            width: 117px;
            font-weight: 600;
          }

          .item-right {
            flex: 1;
          }
        }
      }

      .right {
        flex: 1;
        font-size: 14px;
        text-align: left;

        .item {
          display: flex;
          line-height: 33px;

          .item-left {
            width: 117px;
            font-weight: 600;
          }

          .item-right {
            flex: 1;
          }
        }
      }
    }
  }


}

.dashed-line {
  background: linear-gradient(to left,
      transparent 0%,
      transparent 50%,
      #ccc 50%,
      #ccc 100%);
  background-size: 10px 1px;
  background-repeat: repeat-x;
}

.request-status-box {
  position: absolute;
  right: 15px;
  padding: 0px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  background-color: rgba(0, 0, 0, 0) !important;
  height: 20px;
  line-height: 20px;
}

.request-status-orange {
  border: 1px solid rgb(243, 141, 74);
  color: rgb(243, 141, 74) !important;
}

.request-status-green {
  border: 1px solid $base-green;
  color: $base-green !important;
}

.request-status-red {
  border: 1px solid $base-red;
  color: $base-red !important;
}
.view-file{
  color: #ffffff;
  background-color: #409eff;
  width: 114px;
  height: 30px;
  line-height: 30px;
  margin-top: 2px;
  border-radius: 4px;
  text-align: center;
  cursor: pointer;

  &:hover{
    opacity:0.8;
  }
}
.flex{
    display:flex;
    flex-wrap:wrap;
    text-align: initial;
  }
</style>
